<template>
  <v-container white pa-2 ma-0>
    <v-layout>
      <v-flex xs12 class="title">
        <span style="margin-left:10px;">Share</span>
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 px-2 v-if="showShareError">
        <v-alert
          type="error"
        >
          Couldn't connect to share service. Please check your connection and try again. The error has been sent to our support team.
        </v-alert>
      </v-flex>
      <v-flex xs12 class="item_container">
        <div class="item" @click="createShareFile" @keypress.enter="createShareFile" tabindex="0">
          <v-layout>
            <v-flex style="max-width:60px">
              <v-btn depressed fab light small tabindex="-1">
                <v-icon medium color="secondary">cloud_upload</v-icon>
              </v-btn>
            </v-flex>
            <v-flex style="padding-top: 6px;">
            <p class="item_heading">Share Code</p>
            <p class="item_caption">Create a code or link to share or save a copy of this workspace.</p>
            </v-flex>
            <v-flex text-xs-center style="max-width:60px; padding-top: px;" v-if="connectingToShareService">
              <v-progress-circular
                size="24"
                width="4"
                indeterminate
                color="secondary"
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 class="item_container" v-if="showLiveOption">
        <div class="item" @click="startLiveSession" @keypress.enter="startLiveSession" tabindex="0">
          <v-layout>
            <v-flex style="max-width:60px">
              <v-btn depressed fab light small tabindex="-1">
                <v-icon medium color="secondary">connect_without_contact</v-icon>
              </v-btn>
            </v-flex>
            <v-flex style="padding-top: 6px;">
            <p class="item_heading">
              Live
            </p>
            <p class="item_caption">Join a session with your class to collaborate in real time.</p>
            </v-flex>
            <v-flex text-xs-center style="max-width:60px; padding-top: 12px;" v-if="connectingToLiveService">
              <v-progress-circular
                size="24"
                width="4"
                indeterminate
                color="secondary"
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs6 class="item_container">
        <div class="item" @click="copy" @keypress.enter="copy" tabindex="0">
          <v-layout>
            <v-flex style="max-width:60px">
              <v-btn depressed fab light small tabindex="-1">
                <v-icon medium color="secondary">content_paste</v-icon>
              </v-btn>
            </v-flex>
            <v-flex style="padding-top: 16px;">
            <p class="item_heading">Copy Image</p>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs6 class="item_container">
        <div class="item" @click="download" @keypress.enter="download" tabindex="0">
          <v-layout>
            <v-flex style="max-width:60px">
              <v-btn depressed fab light small tabindex="-1">
                <v-icon medium color="secondary">save_alt</v-icon>
              </v-btn>
            </v-flex>
            <v-flex style="padding-top: 16px;">
            <p class="item_heading">Download Image</p>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  props: {
    connectingToShareService: {
      type: Boolean
    },
    showShareError: {
      type: Boolean
    },
    showLiveOption: {
      type: Boolean,
      default: false
    },
    connectingToLiveService: {
      type: Boolean
    },
    showLiveError: {
      type: Boolean,
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    close () {
      this.$emit("close");
    },
    download () {
      this.$emit("download");
    },
    copy () {
      this.$emit("copy");
    },
    createShareFile () {
      if (this.connectingToShareService || this.connectingToLiveService) return;
      this.$emit("createShare");
    },
    startLiveSession () {
      if (this.connectingToShareService || this.connectingToLiveService) return;
      this.$emit("startLive");
    }
  },
  mounted() {
  },
};
</script>

<style scoped>
.title {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.item_container {
  height: 68px;
  cursor: pointer;
}

.item {
  height: 52px;
  margin: 8px;
  background-color: white;
  border: 1px #DDDEE4 solid;
  border-radius: 4px;
}

.item:hover {
  border: 1px #3296f3 solid;
}
.item:focus {
  border: 1px #3296f3 solid;
}

.item_heading {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
}

.item_caption {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
}
</style>
